module.exports = __webpack_public_path__ + "img/nodata.19d8be67.png";